webpackJsonp([10,18],{

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(18);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(8);

__webpack_require__(140);

__webpack_require__(141);

__webpack_require__(142);

__webpack_require__(15);

var _setupCommonJS = __webpack_require__(16);

var _setupCommonJS2 = _interopRequireDefault(_setupCommonJS);

var _languageBasedTag = __webpack_require__(24);

var _languageBasedTag2 = _interopRequireDefault(_languageBasedTag);

var _wordingJson = __webpack_require__(38);

var _wordingJson2 = _interopRequireDefault(_wordingJson);

var _mediaDetail = __webpack_require__(222);

var _mediaDetail2 = _interopRequireDefault(_mediaDetail);

var _promotionDetail = __webpack_require__(223);

var _promotionDetail2 = _interopRequireDefault(_promotionDetail);

var _scheduleDetail = __webpack_require__(227);

var _scheduleDetail2 = _interopRequireDefault(_scheduleDetail);

var _wordingSetter = __webpack_require__(39);

var _wordingSetter2 = _interopRequireDefault(_wordingSetter);

var _appConfig = __webpack_require__(2);

var _defaultBanner = __webpack_require__(462);

var _defaultBanner2 = _interopRequireDefault(_defaultBanner);

var _setArticleLink = __webpack_require__(209);

var _setArticleLink2 = _interopRequireDefault(_setArticleLink);

var _setArticleDate = __webpack_require__(208);

var _setArticleDate2 = _interopRequireDefault(_setArticleDate);

var _setupTwitterShareLink = __webpack_require__(154);

var _setupTwitterShareLink2 = _interopRequireDefault(_setupTwitterShareLink);

var _setupFacebookShareLink = __webpack_require__(153);

var _setupFacebookShareLink2 = _interopRequireDefault(_setupFacebookShareLink);

var _hideLoadingImage = __webpack_require__(14);

var _hideLoadingImage2 = _interopRequireDefault(_hideLoadingImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _setupCommonJS2.default)();

document.head.appendChild((0, _languageBasedTag2.default)());

var pathArray = window.location.pathname.split('/');

/**
 * get the matched api function
 */
var getData = {
	media: _mediaDetail2.default,
	promotions: _promotionDetail2.default,
	schedules: _scheduleDetail2.default
}[pathArray[2]];

if (pathArray[2] === 'promotions') {
	document.querySelector('.article-wrapper > .information > a.source').classList.add('-booking');
}

var wordingJsonPromise = (0, _wordingJson2.default)('article').then(function (json) {
	return (0, _wordingSetter2.default)(json);
});

/**
 * and then you could call this function without checking
 */
var articlePromise = getData(pathArray[3]).then(function (json) {
	document.querySelector('.banner-wrapper.-article').setAttribute('style', 'background-image: url(' + (json.banner ? _appConfig.uploadUri + '/' + json.banner : _defaultBanner2.default) + ')');
	document.querySelector('.article-wrapper > .title').innerText = json.title;

	(0, _setArticleLink2.default)(json.url);
	(0, _setArticleDate2.default)(pathArray[2], json);

	document.querySelector('.article-wrapper > .content').innerHTML = json.content;

	/**
  * Twitter Share
  */
	(0, _setupTwitterShareLink2.default)(document.querySelector('.share-button > .link.fa-twitter'), '\u3010' + document.title + '\u3011' + json.title);

	/**
  * setup the email link
  */
	document.querySelector('.share-button > .link.fa-envelope-o').setAttribute('href', 'mailto:?subject=' + json.title + '&body=' + window.location.href);

	/**
  * setup the Weibo Share link
  */
	document.querySelector('.share-button > .link.fa-weibo').setAttribute('href', '//service.weibo.com/share/share.php?url=' + window.location.href + '&title=\u3010' + document.title + '\u3011' + json.title + '&pic=' + _appConfig.uploadUri + '/' + json.banner);
}).catch(function (_ref) {
	var errorMsg = _ref.error_msg;

	if (errorMsg === 'NOT_FOUND') {
		/**
   * go to the parent page (list page)
   */
		window.location.href = pathArray[2];
	}
});

Promise.all([wordingJsonPromise, articlePromise]).then(function () {
	return (0, _hideLoadingImage2.default)();
});

/**
 * Facebook Share
 */
(0, _setupFacebookShareLink2.default)(document.querySelector('.share-button > .link.fa-facebook'));

/**
 * go to the previous page
 */
document.querySelector('.back-button').addEventListener('click', function () {
	window.history.back();
});

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var hideDateElement = function hideDateElement() {
	document.querySelector('.article-wrapper > .information > .date').classList.add('-hide');
};

var setDateString = function setDateString(string) {
	document.querySelector('.article-wrapper > .information > .date').innerText = string;
};

var setArticleDate = function setArticleDate(type, data) {
	/**
  * it's a period (from `data_start` to `date_end`)
  */
	if (type === 'promotions') {
		if (!data.date_start || !data.date_end) {
			hideDateElement();
			return;
		}

		setDateString(data.date_start + ' ~ ' + data.date_end);
		return;
	}

	/**
  * only one `date`
  */
	if (!data.date) {
		hideDateElement();
		return;
	}

	setDateString(data.date);
};

exports.default = setArticleDate;

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var setArticleLink = function setArticleLink() {
	var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	if (url) {
		document.querySelector('.article-wrapper > .information > .source').setAttribute('href', url);
		return;
	}

	document.querySelector('.article-wrapper > .information > .source').classList.add('-hide');
};

exports.default = setArticleLink;

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var _handleErrorRequest = __webpack_require__(48);

var _handleErrorRequest2 = _interopRequireDefault(_handleErrorRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaDetail = function mediaDetail(id) {
	return fetch(_appConfig.apiUri + '/report/' + id).then(function (res) {
		return (0, _handleErrorRequest2.default)(res);
	});
};

exports.default = mediaDetail;

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var _handleErrorRequest = __webpack_require__(48);

var _handleErrorRequest2 = _interopRequireDefault(_handleErrorRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promotionDetail = function promotionDetail(id) {
	return fetch(_appConfig.apiUri + '/promotion/' + id).then(function (res) {
		return (0, _handleErrorRequest2.default)(res);
	});
};

exports.default = promotionDetail;

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var _handleErrorRequest = __webpack_require__(48);

var _handleErrorRequest2 = _interopRequireDefault(_handleErrorRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scheduleDetail = function scheduleDetail(id) {
	return fetch(_appConfig.apiUri + '/schedule/' + id).then(function (res) {
		return (0, _handleErrorRequest2.default)(res);
	});
};

exports.default = scheduleDetail;

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlParser = __webpack_require__(9);

var _urlParser2 = _interopRequireDefault(_urlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * this function return a base tag which is base on language path
 *
 * You don't have to add the base tag in every page,
 * just use in the page url which has two or more path after the language, like: `/tw/about/video`.
 * If you are at `/tw/about`, you don't have to add this base tag.
 */
var LanguageBasedTag = function LanguageBasedTag() {
  var baseTag = document.createElement('base');
  baseTag.setAttribute('href', '/' + _urlParser2.default.language + '/');

  return baseTag;
};

exports.default = LanguageBasedTag;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "default-banner.2d607dc6621f5.png";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
__webpack_require__(5);
module.exports = __webpack_require__(186);


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var handleErrorRequest = function handleErrorRequest(response) {
	if (response.status >= 400 && response.status < 500) {
		return response.json().then(function (json) {
			return Promise.reject(json);
		});
	}

	return response.json();
};

exports.default = handleErrorRequest;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[464]);


// WEBPACK FOOTER //
// article.5e37eb27c5831.js